import { observable, action, reaction, remove, makeObservable } from 'mobx';
import axios from 'axios';

class selectStore {
  selected={};
  selectedCount=0;
  par=null;
  constructor(par) {
    makeObservable(this,{
      selected:observable,
      selectedCount:observable,
    });
    this.par=par;
    reaction(()=>{
      return this.selectedCount;
    },()=>{
      this.par.communicatorStore.pushMessage({ type:"output", command:"selected_change", selected_ob:this.selected, count: this.selectedCount });
      console.log('selectedCOunt', this.selectedCount);
    })
  }
  selectAll() {
    this.unselectAll();
    if(this.par.dataStore.data.inited && !this.par.dataStore.data.fetching && this.par.dataStore.data.data.items) {
      const idField=this.par.configStore.config.data.id_field;
      for(let i in this.par.dataStore.data.data.items) {
        this.select(this.par.dataStore.data.data.items[i][idField]);
      }
    }
  }
  unselectAll() {
    this.selected={};
    this.selectedCount=0;
  }
  getIds() {
    const iReturn=[];
    for (let id in this.selected) {
      iReturn.push(id);
    }
    return iReturn;
  }
  select(id) {
    if(!this.selected[id]) {
      this.selected[id] = true;
      this.selectedCount++;
    }
  }
  unselect(id) {
    if(this.selected[id]) {
      delete this.selected[id];
      this.selectedCount--;
    }
  }
  toggle(id) {
    if(this.selected[id]) {
      this.unselect(id);
    } else {
      this.select(id);
    }
  }

}

/*decorate(selectStore,{
  selected:observable,
  selectedCount:observable,
});*/

export default selectStore;
